module.exports = __webpack_public_path__ + "static/img/2.94c8e85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/history/premedical/2.png
// module id = Uktl
// module chunks = 1